import React, { Component, Fragment } from 'react';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import NavTop from '../../containers/NavTop/NavTop';
import {BackTop} from 'antd';
// import PatentHeader from '../../containers/PatentHeader/PatentHeader.js';
import PatentHeader from '../../common/PatentHeader/PatentHeader.js';
import PatentCard from '../../common/Cards/PatentCard/PatentCard';
import QuoteBlock from '../../common/QuoteBlock/QuoteBlock.js';
import ContactSection from '../../containers/ContactSection/ContactSection';
import './PatentsPage.css';

class PatentsPage extends Component {
    constructor(props){
        super(props);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }
    componentWillMount(){
        // let {pageOn} = this.props;
        // console.log(pageOn);
    }

    render(){
        return (
        <Fragment>
            <Helmet>
                <meta charSet="utf-8" />
                <title>RealTimeTouch.com - Patents</title>
                <link rel="canonical" href="http://www.realtimetouch.com/patents/" />
            </Helmet>
            <NavTop pageOn={this.props.pageOn} />
            
            <BackTop />
            <div className="PatentPage--container">
                <div className="PatentPage--container-inner">    
                    <PatentHeader />
                    <div className="PatentsPage--headline-container">
                        <h2 className="PatentsPage--headline ">Patent Features</h2>
                        <h4 className="PatentsPage--subheadline">Real Time Touch inventions include a granted USPTO patent and pending patent applications.</h4>
                        <p className="PatentsPage--body center">Real Time Touch intellectual property could revolutionize telemedicine applications.</p>
                    </div>
                    <QuoteBlock quote="0" />
                    <PatentCard pick="US9639150-Abstract" />
                    {/* <QuoteBlock quote="1" />
                    <PatentCard pick="20170195624-Abstract" /> */}
                    <div className="PatentPage--container-inner-contact">
                        <ContactSection />
                    </div>
                </div>
            </div>
        </Fragment>
        )
    }
}


export default PatentsPage;


// WEBPACK FOOTER //
// ./src/pages/PatentsPage/PatentsPage.js